var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkleSquirkle = function SvgSparkleSquirkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237,
    height: 204,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sparkle-squirkle_svg__a",
    width: 237,
    height: 204,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 203,
    y: 0.028,
    fill: "#D9D9D9",
    rx: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sparkle-squirkle_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sparkle-squirkle_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkle-squirkle_svg__c)",
    d: "m270.676 197.635-.515 1.923c-28.166 105.118-44.017 115.047-147.599 87.532l-2.746-.736C16.367 258.395 7.605 241.872 35.771 136.753c.347-1.296.693-2.586 1.05-3.867 27.43-101.12 44.142-110.762 145.423-83.96.885.224 1.76.458 2.654.698 103.953 27.991 113.428 44.206 85.78 148.005z",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#sparkle-squirkle_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkle-squirkle_svg__e)",
    d: "m247.104 46.572 1.288.743c70.446 40.672 74.548 54.037 34.643 123.499l-1.062 1.84c-40.199 69.281-53.824 72.411-124.27 31.739-.868-.502-1.733-1.001-2.588-1.506-67.701-39.367-71.43-53.298-32.486-121.237.333-.596.671-1.182 1.017-1.781 40.32-69.639 53.86-73.343 123.454-33.3z",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkle-squirkle_svg__f)",
    d: "M215 139.029v-.415c-22.881 0-25.585-2.704-25.585-25.585h-.83c0 22.881-2.704 25.585-25.585 25.585v.83c22.881 0 25.585 2.704 25.585 25.585h.83c0-22.881 2.704-25.585 25.585-25.585z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkle-squirkle_svg__g)",
    d: "M223 164.029v-.144c-7.92 0-8.856-.936-8.856-8.856h-.288c0 7.92-.936 8.856-8.856 8.856v.288c7.92 0 8.856.936 8.856 8.856h.288c0-7.92.936-8.856 8.856-8.856z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sparkle-squirkle_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 24.918 164.082)scale(25.8652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FEFEFE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sparkle-squirkle_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 24.962 189.038)scale(8.95334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FEFEFE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkle-squirkle_svg__c",
    x1: 273.318,
    x2: 23.032,
    y1: 90.654,
    y2: 231.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5FDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#7E5FDD",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583F99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkle-squirkle_svg__e",
    x1: 170.376,
    x2: 232.716,
    y1: 23.968,
    y2: 230.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#FF6F2C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBD6C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sparkle-squirkle_svg__b",
    width: 286.047,
    height: 288.055,
    x: 9.943,
    y: 24.13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_758_28962"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_758_28962",
    result: "effect2_dropShadow_758_28962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_758_28962",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sparkle-squirkle_svg__d",
    width: 234.674,
    height: 233.899,
    x: 85.713,
    y: 8.904,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_758_28962"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_758_28962",
    result: "effect2_dropShadow_758_28962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_758_28962",
    result: "shape"
  })))));
};
export { SvgSparkleSquirkle as ReactComponent };
export default "data:image/svg+xml;base64,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";